import { useTranslate } from '@jablotron/lib.spa-lang';
import { Tag, type TagSize } from '~/components/tag/Tag';
import type { Product } from '~/entities/catalog/types';
import { Texts } from '~/texts/runtime';

/** "Ukončeno" tag shown next to a discontinued product's code wherever the product is listed or detailed. */
export function DiscontinuedBadge({
  product,
  size = 'xs',
  className = '',
}: {
  product: Product;
  /** `xs` inline next to a listed code, `sm` next to the larger code on the product detail. */
  size?: TagSize;
  className?: string;
}) {
  const t = useTranslate();

  if (!product.discontinued) {
    return null;
  }

  return (
    <Tag size={size} uppercase className={className}>
      {t(Texts.ProductDiscontinuedBadge)}
    </Tag>
  );
}
